import {types, getRoot, getSnapshot} from 'mobx-state-tree';
import axios from "axios";
import {autorun} from 'mobx';
import {matchPath} from 'react-router';
import {RouterModel} from "./Router";
import queryString from "query-string";
import {forceCheck} from 'react-lazyload';
import Product from './Product';
import SizeInformation from './SizeInformation';
import Color from './Color';
import Facet from './Facet';
import Tree from './Tree';
import urllite from "urllite";
import {toast} from 'react-toastify';

//import TreeNode from "./TreeNode";
import DataType from './DataType';
import Definition from './Definition';
import MarketSettings from './MarketSettings';

export default types.model('Navigation',
    {
        serverLocation: types.optional(types.string, ""),
        baseUrl: types.optional(types.string, ""),
        mainRouter: RouterModel,
        //toolbarLevel: types.optional(types.number, 0),
        toolbarRouter: RouterModel,
        activePath: types.optional(types.array(types.number), []),
        mobileViewHeight: types.optional(types.number, 0),

        //siteTree: types.optional(Tree, {}),
        mainTree: types.optional(Tree, {}),
        //myPagesTree: types.optional(Tree, {}),
        myPagesTree: types.maybeNull(Tree),

        marketSettings: types.optional(MarketSettings, {}),
        deviceIsTouchEnabled: types.optional(types.boolean, false),
        isMobile: types.optional(types.boolean, true),
        isBot: types.optional(types.boolean, true),
        viewPortWidth: types.optional(types.number, ((typeof window !== 'undefined') ? window.innerWidth : 368)),

        //CurrentUrl: types.optional(types.string, ""),

        ActiveVideo: types.maybeNull(types.string),

        productIndex: types.optional(types.number, 0),
        defaultCustomerId: types.optional(types.string, "!"),
        customerPathRegex: types.optional(types.string, "/:customer([0-9]+)?"),
        dataTypes: types.optional(types.array(DataType), []),
        definitions: types.optional(types.array(Definition), []),
        colors: types.optional(types.array(Color), []),
        products: types.optional(types.array(Product), []),
        totalResults: types.optional(types.number, 0),
        contentProducts: types.optional(types.array(Product), []),
        singleProduct: types.maybeNull(Product),
        ProductModal: types.optional(types.boolean, false),
        facets: types.optional(types.array(Facet), []),
        sizeInformationCollection: types.optional(types.array(SizeInformation), []),

        sortOrder: types.optional(types.string, ""),
        navigationInProgress: types.optional(types.boolean, false),
        navigationVisible: types.optional(types.boolean, false),
        TemplateAlias: types.optional(types.string, ""),
        SiteId: types.optional(types.number, 0),
        NodePath: types.optional(types.string, ""),
        NodeId: types.maybeNull(types.number),
        CultureCode: types.optional(types.string, ""),

        CountryCode: types.maybeNull(types.string),
        MarketCode: types.maybeNull(types.string),
        LanguageCode: types.maybeNull(types.string),


        pageContent: types.optional(types.frozen(), {}),
        footerContent: types.optional(types.frozen(), {}),
        countdownContent: types.optional(types.frozen(), {}),
        ticker: types.optional(types.frozen(), {}),
        urlSkuWithVariantRegex: types.optional(types.string, "*/p/:sku+\\::variant+/:name+/:rest*"),
        urlSkuRegex: types.optional(types.string, "*/p/:sku+/:name+/:rest*"),
        initialUrl: types.optional(types.string, ""),
        dictionary: types.optional(types.frozen(), {}),
        marketSelectorOpen: types.optional(types.boolean, false),
        mainSkinColor: types.optional(types.string, ""),
        recaptchaV2Key: types.optional(types.string, ""),
        SSR_CustomerId: types.maybeNull(types.number),
        navigationCustomerId: types.optional(types.number, 0),

        toolbarLevel: types.optional(types.number, 0),

    }).volatile(self => ({
    //navigationCustomerId: null,
    mstToolbarHistory: {},
    mstMainHistory: null,
    progress: null // react-progress-2
}))

    .views(self => ({

        get account() {
            return getRoot(self).account;
        },

        get analytics() {
            return getRoot(self).analytics;
        },

        get CustomerRoleIsReadOnly() {
            const account = getRoot(self).account;
            if (!account.isLoggedIn) return false;
            const currentCustomer = account.Customers.find(function (item) {
                return self.CustomerId && item.Id === self.CustomerId;
            });
            return (currentCustomer ? currentCustomer.Role : "") === "read-only";
        },

        get order() {
            return getRoot(self).order;
        },

        NodeIsActive(nodeId) {
            const nodeIds = self.NodePath.split(",");
            const tempNodeId = "" + nodeId; // make sure its a string
            let r = false;

            r = nodeIds.indexOf(tempNodeId) > -1;
            //console.log("NodeIsActive", nodeId, nodeIds, r);
            return r;
        },

        get CurrentNode() {
            let currentNode = null;
            if (self.myPagesTree != null) {
                currentNode = self.myPagesTree.getNode(self.NodeId);
                if (currentNode) {
                    return currentNode;
                }
            }

            if (self.marketSettings != null && self.marketSettings.MarketNavigationTree != null) {
                currentNode = self.marketSettings.MarketNavigationTree.getNode(self.NodeId);
                if (currentNode) {
                    return currentNode;
                }
            }

            return self.mainTree.getNode(self.NodeId);
        },

        get ServerRender() {
            return (typeof window === 'undefined')//self.isBot;
        },

        // todo: add CurrentOrderNumber property 
        get UrlCustomerId() {
            return self.getCustomerId();

            //if (!(self.mainRouter && self.mainRouter.location && self.mainRouter.location.search)) { return null; }
            //const parsed = queryString.parse(self.mainRouter.location.search);
            //if (parsed) {
            //    return parsed.cid;
            //}

            //return null;
        },

        getParsedQueryString() {
            //console.log("getParsed", self.mainRouter);
            if (self.mainRouter && self.mainRouter.location && self.mainRouter.location.search) {
                const search = self.mainRouter.location.search;
                const parsed = queryString.parse(search);
                return parsed;
            }
            return {}; // need to be an object to make shallowCompare work
        },

        getQueryFromLocation() {
            if (self.mainRouter && self.mainRouter.location) {
                const query = self.mainRouter.location.search.length > 0
                    ? self.mainRouter.location.search.substring(1)
                    : self.mainRouter.location.search;
                return query;
            }
            return null;
        },

        getReturnFromLocation() {
            var parsed = self.getParsedQueryString();

            if (!parsed || !parsed.return) return null;

            return parsed.return;
            //console.log("parsed q", freeText);

        },

        getFreetextFromLocation() {
            var parsed = self.getParsedQueryString();

            if (!parsed || !parsed.q) return null;

            var freeText = parsed.q;
            //console.log("parsed q", freeText);
            return freeText;
        },

        getSkuAndNameFromLocation() {

            const m = matchPath(self.mainRouter.location.pathname, {path: self.urlSkuRegex});
            if (m !== undefined && m !== null) {
                return m.params["sku"] + "/" + m.params["name"];
            }
        },


        getUrlFromLocation() {
            if (self.mainRouter && self.mainRouter.location) {

                const skuVariantMatch =
                    matchPath(self.mainRouter.location.pathname, {path: self.urlSkuWithVariantRegex});

                const m = matchPath(self.mainRouter.location.pathname, {path: self.urlSkuRegex});
                //console.log("skuVariantMatch2", m);

                //console.debug("getUrlFromLocation", self.mainRouter.location.pathname, self.urlSkuRegex, m);
                if (m !== undefined && m !== null) {
                    //  console.debug(m.params["0"]);
                    return m.params['0'];
                }

                return self.mainRouter.location.pathname;
            }
            return self.initialUrl;
        },

        getProductUrl(product, variantOptions) {

            if (Array.isArray(variantOptions)) {

                const variantKey = ((variantOptions && variantOptions.length > 0) ? ":" : "")
                    + variantOptions.map(gkv => encodeURIComponent(gkv.GroupKey.substr(0, gkv.GroupKey.length - 2)) + "=" + encodeURIComponent(gkv.GroupValue))
                        .join(":");

                const url =
                    self.mainTree.SearchUrl +
                    "/p/" +
                    (product.GroupKey
                        ? encodeURIComponent(product.GroupKey)
                        : encodeURIComponent(product.Sku)) +
                    variantKey
                    + "/" + product.UrlName;

                return url;
            }

            return self.mainTree.SearchUrl + "/p/" + variantOptions;

            //(product.GroupKey
            //    ? encodeURIComponent(product.GroupKey)
            //    : encodeURIComponent(product.Sku))
            //+ variantKey + "/" + product.UrlName;
        },


        getSkuFromLocation() {
            // check url

            if (self.mainRouter && self.mainRouter.location) {

                const skuVariantMatch =
                    matchPath(self.mainRouter.location.pathname, {path: self.urlSkuWithVariantRegex});

                //console.debug("getSkuFromLocation", self.mainRouter.location.pathname, skuVariantMatch);
                if (skuVariantMatch !== undefined && skuVariantMatch !== null) {

                    return {
                        sku: decodeURIComponent(skuVariantMatch.params["sku"]),
                        variant: skuVariantMatch.params["variant"]
                    };
                }

                const skuMatch = matchPath(self.mainRouter.location.pathname, {path: self.urlSkuRegex});
                //console.debug("getSkuFromLocation", self.mainRouter.location.pathname, self.urlSkuRegex, m);
                if (skuMatch !== undefined && skuMatch !== null) {
                    //console.debug("m", m.params["0"]);
                    return {sku: decodeURIComponent(skuMatch.params["sku"]), variant: null};
                }
                return {};
            }


            // check initial querystring 
            let parsed = queryString.parse(self.initialUrl.substring(self.initialUrl.indexOf("?")));
            if (parsed.vid) {
                return {sku: decodeURIComponent(parsed.pid), variant: parsed.vid}
            } else if (parsed.pid) {
                return {sku: decodeURIComponent(parsed.pid)}
            }


            return {};
        },

        getCustomerId() {
            if (this.ServerRender) {
                return self.SSR_CustomerId;
            }

            if (self.mainRouter && self.mainRouter.location) {
                const parsed = queryString.parse(self.mainRouter.location.search);

                if (parsed.cid) {
                    return parseInt(parsed.cid);
                }
            }

            // if (self.account.Customers && self.account.Customers.length === 1) {
            //      return self.account.Customers[0].Id;
            // }

            return undefined;
        },

        getCustomerType() {
            const customerId = self.getCustomerId();
            if (customerId) {

            }
        },

        getSizeInformation(product) {
            let sizeGuid = product.SizeInformationId;

            if (!sizeGuid || !self.sizeInformationCollection) {
                return null;
            }


            let sizeInfo = self.sizeInformationCollection.find(function (item) {
                return item.Guid === sizeGuid;
            });

            return sizeInfo;
        },
        get hasReturnUrl() {
            const parsedQuery = self.getParsedQueryString();
            return parsedQuery && !!parsedQuery.return;
            //return self.mainRouter.location.search && self.mainRouter.location.search.indexOf("?return=") > -1;
        },
        get isFullscreenModalOpen() {
            if (!(self.toolbarRouter && self.toolbarRouter.location)) {
                return false;
            }
            const m = matchPath(self.toolbarRouter.location.pathname, {path: "/(login|choose):rest?"});
            if (m !== undefined && m !== null) {
                return true;
            }
            return false;
        },

        get isToolbarOpen() {
            if (!(self.toolbarRouter && self.toolbarRouter.location)) {
                return false;
            }
            const m = matchPath(self.toolbarRouter.location.pathname, {path: "/(nav|filter|basket|search|account|order|checkout|thankyou|product|mypages):rest?"});

            if (m !== undefined && m !== null) {

                return true;
            }


            return false;
            //todo: change this to something else

        },

        get isProductModalOpen() {
            if (!(self.mainRouter && self.mainRouter.location)) {
                return false;
            }
            const m = matchPath(self.mainRouter.location.pathname, {path: self.mainTree.SearchUrl + "/p/*"});
            if (m !== undefined && m !== null) {
                return true;
            }
            return false;
        },
        get isSearchOpen() {


            if (!(self.toolbarRouter && self.toolbarRouter.location)) {
                return false;
            }
            const m = matchPath(self.toolbarRouter.location.pathname, {path: "/(search):rest?"});

            if (m !== undefined && m !== null) {
                return true;
            }


            return false;
            //todo: change this to something else

        },
        get ProductsView() {
            const serverRender = typeof window === 'undefined';
            const products = self.products;
            const p = products.reduce((r, a) => {
                //r["_" + a.Sku] = r["_" + a.Sku] || [];
                r["_" + a.Sku] = a;
                return r;
            }, []);
            return p;
        },
        get CanUseWebp() {

            const elem = typeof document === 'object' ? document.createElement('canvas') : {};

            if (!!(elem.getContext && elem.getContext('2d'))) {
                // was able or not to get WebP representation
                return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
            } else {
                // very old browser like IE 8, canvas not supported
                return false;
            }
        },

        get ImageFormat() {
            return "jpg"; //self.CanUseWebp ? "webp" : "jpg";
        },

        get TransparentImageFormat() {
            return "png"; //self.CanUseWebp ? "webp" : "png";
        },

        get ActiveCustomerType() {
            return self.account.activeCustomer && self.account.activeCustomer.CustomerType || "personal";
        },

        get isD2C() {
            return (self.ActiveCustomerType === "personal");
        },

        get CurrentUrl() {
            return (self.pageContent && self.pageContent.Url) || self.mainRouter.location.pathname;
        },


    })).actions(self => {
        const disposables = [];
        let toolbarLevel = 0;
        let backNotAvailable = false;
        const isServer = (typeof window === 'undefined');
        let deliveryDateListenerDisposable = null;
        let lastCustomerId = null;
        let lastSiteId = null; // Set default
        let lastUrl = self.getUrlFromLocation();
        //let lastQuerystring = self.getQueryFromLocation();
        let lastParsedQuery = self.getParsedQueryString();
        let lastOrderGuid = null;
        let lastDate = "";

        return {
            afterCreate() {
                //console.debug("init navigation", self.pageContent.Url);

                //lastUrl = self.getUrlFromLocation();
                //lastCustomerId = self.CustomerId = self.pageContent.CustomerId;
                //lastSiteId = self.pageContent.SiteId;
                //setLivelynessChecking("error");
            },

            afterAttach() {

                self.setNavigation(self.mainTree.toJSON());
                if (!isServer) {
                    disposables.push(autorun(() => {
                        if (self.isToolbarOpen) {
                            //document.body.classList.add("toolbar-open");
                        } else {
                            //document.body.classList.remove("toolbar-open");
                        }
                        if (self.isSearchOpen) {

                            //document.body.classList.add("search-open");
                        } else {
                            //document.body.classList.remove("search-open");
                        }
                    }));

                    disposables.push(autorun(() => {
                        var isD2C = self.isD2C;
                        self.analytics.setCustomerType();
                    }));


                    // disposables.push(autorun(() => {
                    //     const key = self.mainRouter.location.key;
                    //     const action = self.mainRouter.action;
                    //     const location = self.mainRouter.location
                    //     const hash = self.mainRouter.location.hash
                    //     const state = self.mainRouter.location.state;
                    //    
                    //     const stateToolbarLevel = parseInt(state);
                    //
                    //     if (hash !== "") {
                    //         if (self.toolbarLevel === 0 && action === "PUSH") {
                    //             //toolbarLevel += 1;
                    //             self.setToolbarLevel(self.toolbarLevel + 1);
                    //         } else if (toolbarLevel > 0) {
                    //             if (action === "PUSH") {
                    //                 //toolbarLevel += 1;
                    //                 self.setToolbarLevel(self.toolbarLevel + 1);
                    //             } else if (action === "POP") {
                    //                 //if (state !== "hashLocation") {
                    //                 if(stateToolbarLevel > 0) {
                    //                     // Back button used
                    //                     //toolbarLevel -= 1;
                    //                    
                    //                     self.setToolbarLevel(self.toolbarLevel - 1);
                    //                 } else {
                    //                     // Forward button on browser used
                    //                     //toolbarLevel += 1;
                    //                     //self.setToolbarLevel(self.toolbarLevel - 1);
                    //                 }
                    //             }
                    //         }
                    //         if(self.toolbarLevel === 0 && action === "POP" || action === "REPLACE"){
                    //             //toolbarLevel = 1;
                    //             //backNotAvailable = true;
                    //         }
                    //     }
                    //     else{
                    //         //debugger;
                    //         if(self.toolbarLevel > 0 && action === "POP"){
                    //            
                    //            //toolbarLevel -= 1;
                    //             self.setToolbarLevel(self.toolbarLevel - 1);
                    //         }
                    //        
                    //         if(self.toolbarLevel > 0 && action === "REPLACE"){
                    //             //toolbarLevel = 0; // Reset
                    //            
                    //         }
                    //     }
                    //
                    //     console.log("autorun -> ", key, action, location, state, self.toolbarLevel, backNotAvailable);
                    //
                    // }));


                }
            },

            setToolbarLevel(level) {
                self.toolbarLevel = level;
            },

            activateUrlAndCustomerListener() {


                lastUrl = self.getReturnFromLocation() || self.getUrlFromLocation();
                //lastQuerystring = self.getQueryFromLocation();
                lastParsedQuery = self.getParsedQueryString();
                if (lastParsedQuery && lastParsedQuery.return) {
                    delete lastParsedQuery.return;
                }

                lastCustomerId = self.getCustomerId();
                lastSiteId = self.pageContent.SiteId;

                self.updateFacetsAndSortFromLocation();


                if (self.getCustomerId()) {
                    self.order.fetchOrders().then(() => {
                        //self.activateDeliveryDateListener();
                    });
                }

                //console.debug("activateUrlAndCustomerListener", lastCustomerId);

                disposables.push(autorun(() => {
                    //if (self.getSkuFromLocation() && !self.hasReturnUrl()) {
                    //    // Do not fetch content on ProductModal
                    //    return;
                    //}


                    //console.log("navigation:: sku:", self.getSkuFromLocation(), "return:" + self.getReturnFromLocation(), "hasReturn: " + self.hasReturnUrl());
                    if (self.mainRouter && self.mainRouter.location && self.mainRouter.location.pathname) {//&& self.mainRouter.location.pathname) {


                        const url = self.getReturnFromLocation() || self.getUrlFromLocation();
                        //const queryString = self.getQueryFromLocation();
                        const parsedQuery = self.getParsedQueryString();
                         if (parsedQuery && parsedQuery.return) {
                             delete parsedQuery.return;
                         }

                        const customerId = self.getCustomerId();

                        self.updateFacetsAndSortFromLocation();

                        console.debug("navigation: newUrl: " + url, "lastUrl: " + lastUrl, "queryString: " + queryString, "parsedQuery", parsedQuery, "lastParsedQuery", lastParsedQuery, "customerId", customerId, "lastCustomerId", lastCustomerId);

                        if (lastUrl !== url
                            || !shallowEqual(lastParsedQuery, parsedQuery)
                            || customerId !== lastCustomerId) {
                            self.setNavigationInProgress(true);
                            if (self.progress) {
                                self.progress.show();
                            }
                            //console.debug("progress:", self.progress);
                            self.GetContent("only url changed from: " + lastUrl, lastUrl).then((success) => {
                                    //console.debug("get content completed...");
                                    self.setNavigationInProgress(false);
                                    if (self.progress) {
                                        self.progress.hide();
                                    }
                                },
                                (error) => {
                                    console.debug("getcontent error...", error);
                                    if (self.progress) {
                                        self.progress.hide();
                                    }
                                    self.setNavigationInProgress(false);

                                });
                        }

                        if (customerId !== lastCustomerId || self.SiteId !== lastSiteId) {
                            console.debug("fetchOrders");
                            self.order.fetchOrders().then(() => {
                                //self.activateDeliveryDateListener();
                            });
                        }

                        lastSiteId = self.SiteId;
                        lastCustomerId = customerId;
                        lastUrl = url;
                        lastParsedQuery = parsedQuery;
                    }
                }));
            },


            setActiveVideo(ref) {
                self.ActiveVideo = ref;
            },

            setTouchEnabled() {
                self.deviceIsTouchEnabled = true;
            },

            setIsMobile(value) {
                self.isMobile = value;
            },

            setViewPortWidth(value) {
                self.viewPortWidth = value;
            },

            // setTooolbarLevel(level) {
            //     self.toolbarLevel = level;
            // },


            activateDeliveryDateListener() {
                console.debug("activateDeliveryDateListener");
                lastDate = self.order.activeOrder ? self.order.activeOrder.DeliveryDate : lastDate;
                lastOrderGuid = self.order.activeOrder ? self.order.activeOrder.OrderGuid : lastOrderGuid;

                deliveryDateListenerDisposable = autorun(() => {
                    if (self.order.activeOrder) {
                        console.debug("autorun: activateDeliveryDateListener", lastDate, self.order.activeOrder.DeliveryDate);
                        const date = self.order.activeOrder.DeliveryDate;
                        const orderGuid = self.order.activeOrder.OrderGuid;

                        if (date !== lastDate || orderGuid !== lastOrderGuid) {
                            lastDate = date;
                            lastOrderGuid = orderGuid;
                            self.GetContent("orderguid or date changed");
                        }
                    }
                });
            },


            getSearchFromFacets() {

                let q = self.getFreetextFromLocation();

                let f = "";
                //console.log("facets", self.facets.toJSON());
                for (const facet of self.facets.filter(x => x.Name !== "CategoryIds" && x.Name !== "SubCategories")) {
                    let fPart = "";
                    for (const v of facet.FacetValues) {
                        if (v.Selected) {
                            fPart += v.Value + ",";
                        }
                    }
                    if (fPart && fPart[fPart.length - 1] === ",") {
                        fPart = fPart.substr(0, fPart.length - 1);
                    }
                    if (fPart.length > 0 || facet.Dirty) {
                        f += (f.length > 0 ? "|" : "") + facet.Name + ":" + fPart;
                    }
                }

                if (q && q.length > 0) {
                    q = "q=" + q;
                }

                if (f.length > 0) {
                    f = "f=" + f;
                }

                // add sort
                let sort = "";
                if (self.sortOrder.length > 0) {
                    sort = "sort=" + self.sortOrder;
                }

                let part1 = (q ? q : "") + (q && q.length > 0 ? "&" : "") + f;

                return part1 + (part1 && part1.length > 0 && sort.length > 0 ? "&" : "") + sort;
            },

            updateLocationWithoutFacets(url = null) {
                self.navigateToSiteUrl(null, url, null, null, "", "");
            },

            updateLocationFromFacets(url = null) {
                self.navigateToSiteUrl(null, url, null, null, self.getSearchFromFacets());
            },

            updateFacetsAndSortFromLocation() {
                var parsed = self.getParsedQueryString();
                if (!parsed || (!parsed.f && !parsed.sort)) {
                    self.sortOrder = "";
                    return null;
                }

                if (parsed.f) {
                    var selectedFacets = parsed.f;
                    var facets = selectedFacets.split("|");
                    for (const f of facets) {
                        const facetData = f.split(":");
                        const key = facetData[0];
                        const selectedFacetValues = facetData[1].split(",");

                        // find facet
                        const facet = self.facets.find(x => x.Name === key);
                        if (facet) {
                            for (const v of facet.FacetValues) {
                                if (selectedFacetValues.indexOf(v.Value) > -1) {
                                    v.Selected = true;
                                }
                            }
                        }
                    }
                }

                if (parsed.sort) {
                    self.sortOrder = parsed.sort;
                }
            },

            toggleSortOrder(sortOptionValue) {
                //console.debug("toggleSortOrder", sortOptionValue);
                self.sortOrder = sortOptionValue;
                self.updateLocationFromFacets();
            },

            toggleFacetOption(facetName, facetOptionValue, url = null) {
                const facet = self.facets.find(x => x.Name === facetName);
                const facetOption = facet.FacetValues.find(x => x.Value === facetOptionValue);
                if (facetOption) {
                    facetOption.Selected = !facetOption.Selected;
                    facet.Dirty = true;
                }

                if (facet.IsFilter) {
                    url = self.mainTree.SearchUrl;
                }

                self.updateLocationFromFacets(url);
            },

            clearAll(url = null) {
                const query = queryString.parse(self.mainRouter.location.search);
                self.navigateToSiteUrl(null, self.mainTree.SearchUrl, null, null, null);
            },

            clearAllFacets(url = null) {
                self.facets.map(facet => {
                    facet.FacetValues.map(value => {
                        value.Selected = false;
                    });
                });
                self.updateLocationFromFacets(url);
            },

            clearFreeText() {
                const query = queryString.parse(self.mainRouter.location.search);
                if (query["q"]) {
                    delete query["q"];
                }
                self.navigateToSiteUrl(null, self.mainTree.SearchUrl, null, null, queryString.stringify(query));
            },


            setFacetValue(facetName, selectedValues) {

                const facet = self.facets.find(x => x.Name === facetName);

                for (const facetValue of facet.FacetValues) {
                    const result = selectedValues.indexOf(facetValue.Value) > -1;
                    //console.log("setFacetValue: ", selectedValues, facetValue.Value, result);
                    facetValue.Selected = result;
                }


                //console.log("updated facet", facet.toJSON());

                self.updateLocationFromFacets();
            },


            setMstToolbarHistory(history) {
                self.mstToolbarHistory = history;
            },


            setMstMainHistory(history) {
                self.mstMainHistory = history;
            },


            setProgress(progress) {
                self.progress = progress;
            },

            setNavigationInProgress(value) {
                self.navigationInProgress = value;
            },

            setNavigationVisible(value) {
                self.navigationVisible = value;
            },

            setMarketSelectorVisible(value) {
                self.marketSelectorOpen = value;
            },
            toogleMarketSelectorVisible() {
                self.marketSelectorOpen = !self.marketSelectorOpen;
            },

            toast(value) {
                toast(value);
            },

            toastError(value) {
                toast.error(value);
            },

            async GetNavigation(siteId, sender) {
                //console.debug("GetNavigation", siteId, sender);

                if (!siteId) {
                    siteId = self.mainTree.Id;
                }
                if (self.progress) {
                    self.progress.show();
                }
                const res = await self.request("/Umbraco/Api/Content/GetNavigation?sid=" + siteId, {
                    CustomerId: self.UrlCustomerId,
                    SiteId: siteId,
                    CultureCode: self.CultureCode,
                    CountryCode: self.CountryCode,
                });

                self.setNavigation(res.Navigation);

                if (self.progress) {
                    self.progress.hide();
                }
            },

            async GetMyPages(siteId, sender) {
                //console.debug("GetNavigation", siteId, sender);

                if (!siteId) {
                    siteId = self.mainTree.Id;
                }
                const res = await self.request("/Umbraco/Api/Content/GetMyPages?sid=" + siteId, {
                    CustomerId: self.UrlCustomerId,
                    SiteId: siteId
                });

                self.setMypagesNavigation(res.MyPages);
               
            },

            setNavigation(treeData) {
                self.mainTree = treeData;
                self.navigationCustomerId = self.UrlCustomerId;
            },

            setSites(siteTree) {
                self.siteTree = siteTree;
            },

            setMypagesNavigation(source) {
                if (self.account.isLoggedIn) {
                    //console.debug("Setmypagesnavigation is logged in", source);
                    self.myPagesTree = source;
                }
            },

            async GetContent(sender, lastUrl, productsFrom = 0) {
                const serverRender = typeof window === 'undefined';
                //const returnUrl = 
                const url = self.getReturnFromLocation() || self.getUrlFromLocation();
                const query = self.getQueryFromLocation();

                const urlChanged = lastUrl && lastUrl !== url;
                console.debug("GetContent -> query", sender, url, lastUrl);

                const res = await self.request("/Umbraco/Api/Content/Getnode?url=" + url.replace("?", "&") + (query ? ("&" + query) : ""),
                    {
                        MarketCode: self.MarketCode,
                        CultureCode: self.CultureCode,
                        CountryCode: self.CountryCode,
                        Url: url,
                        CustomerId: self.UrlCustomerId,
                        ProductsFrom: productsFrom ? productsFrom : 0,
                        ProductsCount: 24,
                        ProductsOrderBy: "score",
                        ProductsOnly: !urlChanged,

                        AdditionalData: {"DeliveryDate": self.order.activeOrder ? self.order.activeOrder.DeliveryDate : null}
                    });

                self.updateFacetsAndSortFromLocation();
                const navigationComplete = await self.setContent(res, productsFrom, url);


                if (!navigationComplete) {
                    !serverRender && console.debug("goBack");
                    self.mainRouter.goBack();
                }
                //self.progress.hide();
                return res;
            },


            async GetGrid(url) {
                const serverRender = typeof window === 'undefined';

                const res = await self.request("/Umbraco/Api/Content/Getnode?url=" + url.replace("?", "&"), //self.currentUrl,
                    {
                        Url: url,
                        CustomerId: self.UrlCustomerId,
                        MarketCode: self.MarketCode,
                        CultureCode: self.CultureCode,
                        ContentOnly: true

                    });

                return res;
            },


            async setContent(content, productsFrom, url) {
                console.debug("setContent");
                if (content) {

                    if (content.status && content.status === "error") {
                        alert("The content requested could not be loaded");
                        return false;
                    }


                    //self.CurrentUrl = url;
                    self.NodeId = content.Id;
                    self.NodePath = content.NodePath;
                    self.TemplateAlias = content.TemplateAlias;
                    self.SiteId = content.SiteId;
                    self.CultureCode = content.CultureCode;
                    self.CustomerId = content.CustomerId;


                    if (content.Properties) {
                        self.pageContent = content;
                    }

                    if (productsFrom && productsFrom > 0) {
                        self.products = [...self.products, ...content.Products];
                        return true;
                    }

                    self.contentProducts = [];
                    if (content && content.ContentProducts) {
                        //console.debug("SET new contentProducts", content.ContentProducts);
                        self.contentProducts = content.ContentProducts;
                    }

                    self.totalResults = 0;
                    self.productIndex = 0;
                    //self.products = [];

                    if (content && content.Products) {
                        //console.debug("SET new products", content.Products);
                        self.products = content.Products;
                        self.totalResults = content.TotalResults;
                    } else {
                        self.products = [];
                    }


                    if (content && content.Facets) {
                        self.facets = content.Facets;
                        //console.debug("setContent -> Facets", self.facets.toJSON());
                    } else {
                        self.facets = [];
                    }


                    if (content && content.Countries) {
                        self.mainTree.Countries = [];
                        self.mainTree.Countries = content.Countries;
                    } else {

                    }

                    //forceCheck();
                    setTimeout(() => {
                        forceCheck();
                    }, 1000);

                }


                // If we change site, or customer, refetch navigation
                //console.log("getNavigaion", self.pageContent, self.mainTree, self.mainTree.Id, self.SiteId, self.navigationCustomerId, self.CustomerId )
                if (self.pageContent && self.mainTree && (self.mainTree.Id !== self.SiteId) || (self.navigationCustomerId !== self.CustomerId)) {// ) {
                    await self.GetMyPages(self.SiteId, "setContent");
                    await self.GetNavigation(self.SiteId, "setContent");
                }
                return true;
            },


            resetProductindex() {
                self.productIndex = 0;
            },

            getNextProductIndex() {
                return self.productIndex++;
            },

            setSingleProduct(product) {
                self.singleProduct = product;
            },

            async setLocationSearch(search) {
                return await this.navigateToSiteUrl(null, null, null, null, search);
            },

            async navigateToSiteUrl(tree, url, title, memoryPath = null, search = "", hashPath = null) {
                if (url && url.indexOf("?") > -1) {
                    const urlLocation = url.substring(0, url.indexOf("?"));
                    const urlSearch = url.substring(url.indexOf("?"));
                    url = urlLocation;
                    search = urlSearch;
                }


                if (search === null) {
                    search = "";
                }

                //console.debug("navigateToSiteUrl:", url, "hashPath:", hashPath, "search:", search);

                const customerId = self.getCustomerId();

                tree = tree == null ? self.mainTree : tree;
                if (memoryPath === null) {

                    //const hashQuery = queryString.parse(self.mainRouter.location.hash);
                    const searchQuery = queryString.parse(self.mainRouter.location.search);

                    if (typeof search === "string") {
                        search = queryString.parse(search);
                    }

                    if (typeof memoryPath === "string") {
                        memoryPath = queryString.parse(memoryPath);
                    }
                    //
                    // if(search) {
                    //     for(const key of Object.keys(search)){
                    //         console.log("key",key);
                    //         if(searchQuery[key] !== null && search[key] === null){
                    //             delete searchQuery[key];
                    //         }
                    //         else
                    //         {
                    //             searchQuery[key] = search[key];
                    //         }
                    //     }
                    // }

                    const newHistoryObject = {
                        pathname: url === null ? self.mainRouter.location.pathname : url, //url,
                        search: search === null ? queryString.stringify(searchQuery) : queryString.stringify({...search, cid: customerId}), // search === null ? self.mainRouter.location.search : search,
                        hash: hashPath === null ? self.mainRouter.location.hash : hashPath
                        // queryString.stringify(hashQuery)
                    };


                    //console.debug("NEWPATH", url, newHistoryObject);


                    //if (hashUrl) {    
                    //    self.toolbarRouter.push(hashUrl);
                    //}

                    if (self.mainRouter.location.hash) {
                        self.mainRouter.replace(newHistoryObject);
                    } else {
                        self.mainRouter.push(newHistoryObject);
                    }


                    self.setNavigationVisible(false);

                    // todo: senderTree...
                    if (tree) {
                        tree.resetNavigation();
                    }
                } else {

                    const regex = tree.NavigationRootRegex;
                    const m = matchPath(self.toolbarRouter.location.pathname, {path: regex + "*"});
                    console.debug("hashUrl", m);
                    let newPath = regex; // create a new Path from template
                    if (m) {
                        const matchNames = Object.getOwnPropertyNames(m.params);
                        matchNames.forEach((matchKey) => {
                            if (matchKey !== "0") {
                                const searchPattern = "/:" + matchKey;
                                const replaceWith = "/" + m.params[matchKey];
                                newPath = newPath.replace(searchPattern, replaceWith);
                            }
                        });
                    } else {
                        newPath = tree.NavigationRootRegex;
                    }
                    newPath = newPath + memoryPath;
                    console.debug("Navigation.js > navigateToSiteUrl > newPath", newPath, memoryPath);
                    self.toolbarRouter.push(newPath);
                }
            },

            aHrefNavigation(e) {

                // Use this for onClick on Divs to support querystrings and hashkeys on url
                // Example;
                // <div 
                // 
                //                         onClick={(e) => props.store.navigation.aHrefNavigation(e)}>
                //  <a href="/page/id>Link></a>
                // </div>

                // Ignore canceled events, modified clicks, and right clicks.
                if (e.defaultPrevented) {
                    return;
                }

                if (e.metaKey || e.ctrlKey || e.shiftKey) {
                    return;
                }

                if (e.button !== 0) {
                    return;
                }

                // Get the <a> element.
                var el = e.target;
                while (el && el.nodeName !== 'A') {
                    el = el.parentNode;
                }

                // Ignore clicks from non-a elements.
                if (!el) {
                    return;
                }

                // Ignore the click if the element has a target.
                if (el.target && el.target !== '_self') {
                    return;
                }

                // Ignore the click if it's a download link. (We use this method of
                // detecting the presence of the attribute for old IE versions.)
                if (el.attributes.download) {
                    return;
                }


                //console.debug("NAVIGATE!:", el);
                // Ignore hash (used often instead of javascript:void(0) in strict CSP envs)
                const href = el.getAttribute('href');
                if (href && href.length > 0 && href[0] === '#') { // && !(this.props.environment instanceof HashEnvironment)) {
                    return;
                }

                var url = urllite(el.href);
                var windowURL = urllite(window.location.href);

                // Ignore links that don't share a protocol and host with ours.
                if (url.protocol !== windowURL.protocol || url.host !== windowURL.host) {
                    return;
                }

                // Ignore 'rel="external"' links.
                if (el.rel && /(?:^|\s+)external(?:\s+|$)/.test(el.rel)) {
                    return;
                }

                // Prevent :focus from sticking; preventDefault() stops blur in some browsers
                el.blur();
                e.preventDefault();


                console.debug("NAVIGATE", url.protocol, windowURL.protocol);

                self.navigateToSiteUrl(null, url.pathname, null, null, url.search);
            },


            getTreePath(tree) {
                const navigationRootRegex = tree.NavigationRootRegex;
                const m = matchPath(self.toolbarRouter.location.pathname, {path: navigationRootRegex + "/:rest*"});
                if (m !== undefined && m !== null && m.params["rest"]) {
                    return "/" + m.params["rest"];
                }
                return "";
            },

            // closeToolbar() {
            //     self.toolbarRouter.push("/");
            // },


            setProductModal(value) {
                self.ProductModal = value;
            },
            openProductDialog(product, options) {
                //useToolbarRouter = false, replaceProduct = true) {

                if (options && options.useToolbarRouter) {
                    self.toolbarRouter.push("/product/" + product.Sku);

                } else {

                    //console.log("location.search", self.mainRouter.location.search, self.mainRouter.location.pathname);
                    //console.log("openProductDialog", options)
                    //const parsed = queryString.parse(self.mainRouter.location.search);

                    //const search =
                    //    !parsed.return
                    //        ? self.mainRouter.location.search +
                    //        (self.mainRouter.location.search
                    //            ? "&"
                    //            : "?") +
                    //        "return=" +
                    //        self.mainRouter.location.pathname
                    //        : self.mainRouter.location.search;
                    var variantOptions = options && options.variantOptions;

                    self.navigateToSiteUrl(null, self.getProductUrl(product, variantOptions), null, null, self.getSearchParameters());
                    self.analytics.productClick(product, self.pageContent.Title, options && options.listIndex);
                }
            },


            getSearchParameters() {
                //if (self.mainRouter.location && self.mainRouter.location.search) {
                const parsed = queryString.parse(self.mainRouter.location.search);
                
                const variantMatch = matchPath(self.mainRouter.location.pathname, {path: self.urlSkuWithVariantRegex});
                const productMatch = matchPath(self.mainRouter.location.pathname, {path: self.urlSkuRegex});

                const noReturn = variantMatch !== null || productMatch != null;

                const search =
                    !parsed.return && !noReturn
                        ? self.mainRouter.location.search + (self.mainRouter.location.search ? "&" : "?") +

                        "return=" + self.mainRouter.location.pathname
                        : self.mainRouter.location.search;

                return search;

            },

            closeProductDialog(useToolbarRouter) {
                if (useToolbarRouter) {
                    self.toolbarRouter.push("/");
                } else {
                    //console.debug("router:", self.mainRouter);

                    //self.mainRouter.goBack();
                    self.navigateToSiteUrl(null, self.getUrlFromLocation(), null, null, self.getSearchFromFacets());
                    //self.mainRouter.push(self.getUrlFromLocation());
                }
            },

            getHashLocation(hashPath) {
                const nextLevel = (!isNaN(parseInt(self.mainRouter.location.state)) ? parseInt(self.mainRouter.location.state)+1 : 0);
                return self.mainRouter
                    ? {
                        pathname: self.mainRouter.location.pathname,
                        search: self.mainRouter.location.search,
                        hash: hashPath,
                        state: nextLevel
                    } : null;
            },

            gotoRoot() {
                window.location.href = "/";
            },

            openNewOrder() {
                if (self.UrlCustomerId) {
                    window.location.href = "/?cid=" + self.UrlCustomerId + "#/choose";
                } else {
                    window.location.href = "/#choose";
                }

            },

            openChooseCustomer() {
                // reset app by refetch 
                window.location.href = "/#/choose";
            },

            openLogin() {
                self.toolbarRouter.push("/login");
            },

            openChoose() {
                self.toolbarRouter.push("/choose");
            },

            openOrder() {
                self.toolbarRouter.push("/order");
            },

            openBasket() {
                self.toolbarRouter.push("/basket");
            },
            openPurchaseOrder() {
                //self.toolbarRouter.push("/order");
                self.mainRouter.push(self.getHashLocation("/order"));
            },

            openCheckout() {
                //self.toolbarRouter.push("/order/checkout");
                self.mainRouter.push(self.getHashLocation("/order/checkout"));
            },

            openFilter() {
                self.mainRouter.push(self.getHashLocation("/filter"));
            },

            openSort() {
                self.mainRouter.push(self.getHashLocation("/sort"));
            },

            openD2CCheckout() {
                self.navigateToSiteUrl(null, self.mainTree.CheckoutUrl);
            },

            closeToolbar(forceReplaceUrl = false, fnCallBack) {
                console.debug("ToolbarDropdown > close()", forceReplaceUrl);
                //const navigation = this.props.store.navigation;
                const mainRouter = self.mainRouter;

                //const replace = mainRouter.location && mainRouter.location.hash && mainRouter.location.hash.length > 2 && mainRouter.location.hash.charAt(1) === '/';// && mainRouter.action === "POP"

                const toolbarLevelState = !isNaN(parseInt(mainRouter.location.state)) ? parseInt(mainRouter.location.state) : 0;
                if (toolbarLevelState > 0 && !forceReplaceUrl) {
                    mainRouter.go(-toolbarLevelState);
                } else {
                    mainRouter.replace({pathname: mainRouter.location.pathname, search: mainRouter.location.search, hash: "", state: null});
                }


                // if (backNotAvailable || forceReplaceUrl || self.toolbarLevel === 0 ) {
                //     toolbarLevel = 0;
                //     backNotAvailable = false;
                //     mainRouter.replace({pathname: mainRouter.location.pathname, search: mainRouter.location.search, hash: ""})
                // } else {
                //     //mainRouter.goBack();
                //     mainRouter.go(-toolbarLevel);
                //     toolbarLevel = 0;
                // }

                //navigation.toolbarRouter.push("/");
                self.setNavigationVisible(false);
                
                if(fnCallBack)
                {
                    fnCallBack();
                }
            },

            openOrderAdd(replace = false) {
                const location = self.getHashLocation("/order/add");
                if (replace) {
                    self.mainRouter.replace(location);
                } else {
                    self.mainRouter.push(location);
                }

                //self.toolbarRouter.push("/order/add");
            },

            openOrderSettings() {
                //self.toolbarRouter.push("/order/settings");
                self.mainRouter.push(self.getHashLocation("/order/settings"));
            },

            openThankYou(orderNumber) {
                if (orderNumber) self.mainRouter.replace(self.getHashLocation(`/order/thankyou/${orderNumber}`));
                else self.mainRouter.replace(self.getHashLocation("/order/thankyou"));
                //self.toolbarRouter.push("/order/thankyou");
            },

            openSizeChart() {
                self.toolbarRouter.push("/sizechart");
            },

            closeChoose() {
                self.toolbarRouter.push("/");
            },


            setCustomer(customer) {
                //console.debug(customer);
                if (customer !== null) {
                    self.account.setCustomer(customer);
                }
            },

            setLocationCustomerId(customerId) {

                // todo: handle ordernumber


                let searchQuery = queryString.parse(self.mainRouter.location.search);
                searchQuery.cid = customerId;


                const newHistoryObject = {
                    pathname: self.mainRouter.location.pathname, //newLocation, 
                    search: queryString.stringify(searchQuery), //"cid=" + customerId,
                    hash: self.mainRouter.location.hash //: self.CustomerUrl
                };

                //console.debug("setLocationCustomerId: ", newLocation);
                if ((typeof window !== 'undefined')) {
                    self.mainRouter.push(newHistoryObject);
                }

            },

            getSortOptions() {
                const options = [
                    {
                        Name: self.dictionary.SortOptionRelevanceAsc,
                        Value: ''
                    },
                    {
                        Name: self.dictionary.SortOptionNewestDesc,
                        Value: 'sortdatetime-desc'
                    },
                    // {
                    //     Name: self.dictionary.SortOptionPopularDesc,
                    //     Value: 'popular'
                    // },
                    {
                        Name: self.dictionary.SortOptionPriceAsc,
                        Value: 'price-asc'
                    },
                    {
                        Name: self.dictionary.SortOptionPriceDesc,
                        Value: 'price-desc'
                    },
                    {
                        Name: self.dictionary.SortOptionNameAsc,
                        Value: 'name-asc'
                    },
                    {
                        Name: self.dictionary.SortOptionNameDesc,
                        Value: 'name-desc'
                    }
                ];
                return options;
            },

            getNodes(currentPath) {
                const pathArray = currentPath.split(",").map(Number); // split and convert to int
                const nodes = [];
                // find site, dig from there

                // find current node in navigationTree
                var currentNode = self.mainTree;


                let index = pathArray.indexOf(currentNode.Id);
                // Try to find next level
                do {
                    index = index + 1;

                    let nodeId = pathArray[index];
                    if (!currentNode) return null;
                    currentNode = currentNode.Children.find(x => x.Id === nodeId);
                    if(currentNode) {
                        nodes.push(currentNode);
                    }
                } while ((pathArray.length - 1) > index)

                return nodes;
            },

            getBreadcrumb(currentPath) {
                var nodes = self.getNodes(currentPath);
                return nodes;
            },

            forceLazy() {
                forceCheck();
            },

            async getProductSingle(sku, cancelToken) {

                const res = await self.request("/Umbraco/Api/Content/GetProductSingle",
                    {
                        Sku: sku,
                        SiteId: self.SiteId,
                        CustomerId: self.getCustomerId(),
                        CultureCode: self.CultureCode,
                        MarketCode: self.MarketCode,
                        CountryCode: self.CountryCode

                    },
                    {
                        cancelToken: cancelToken
                    });


                return res;
            },

            async request(path, query = {}) {
                const res = await axios.post(`${path}`, query);
                return res.data;
            }
        }
    });


function is(x, y) {
    // SameValue algorithm
    if (x === y) { // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        // Added the nonzero y check to make Flow happy, but it is redundant
        return x !== 0 || y !== 0 || 1 / x === 1 / y;
    } else {
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
}


/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
    if (is(objA, objB)) {
        return true;
    }

    if (typeof objA !== 'object' || objA === null ||
        typeof objB !== 'object' || objB === null) {
        return false;
    }

    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);

    if (keysA.length !== keysB.length) {
        return false;
    }

    // Test for A's keys different from B.
    for (let i = 0; i < keysA.length; i++) {
        if (
            !hasOwnProperty.call(objB, keysA[i]) ||
            !is(objA[keysA[i]], objB[keysA[i]])
        ) {
            return false;
        }
    }

    return true;
}

